export const GET_ORDINANCE_REVISION_EFFECTIVITY = 'GET_ORDINANCE_REVISION_EFFECTIVITY/get_ordinance_revision_effectivity';
export const GET_FORMDATA_ORDINANCE_REVISION = 'GET_FORMDATA_ORDINANCE_REVISION/get_formdata_ordinance_revision'
export const GET_FORMDATA_ORDINANCE_REVISION_DEFAULT = 'GET_FORMDATA_ORDINANCE_REVISION_DEFAULT/get_formdata_ordinance_revision_default'
export const GET_REPORTS = 'module_distribution/get_reports';
export const GET_REPORT_LIST = 'module_distribution/get_report';
export const GET_TRANSACTIONAL_REPORT_LIST = 'module_distribution/get_transactional_report';
export const GET_EXPORT_LIST = 'module_distribution/get_export';
export const GET_PREVIEW_LINK = 'module_distribution/get_preview_link';
export const LIST = 'bpls_report/list';
export const GENERATE_AUDIT_LOG = 'module_distribution/generate_audit_log';
export const GENERATE_TRANSACTIONAL_AUDIT_LOG = 'module_distribution/generate_transactional_audit_log';

// export const Reports_URI = '/api/v1/administrators/report_file_exports_download/{id}/preview';
export const BPLS_MODULE_TYPE = [
  { label: 'Add', value: 'Add'},
  { label: 'Modify', value: 'Modify'},
  { label: 'Delete', value: 'Delete'},
  { label: 'Log-in', value: 'Log-in'},
  { label: 'Log-out', value: 'Log-out'},
  { label: 'Blocked', value: 'Blocked'},
]

export const MODULE = [
  { label: 'BPLS', value: 'BPLS_AUDIT'},
  { label: 'Birth Certificate', value: 'BIRTH_CERTIFICATE_AUDIT'},
  { label: 'Death Certificate', value: 'DEATH_CERTIFICATE_AUDIT'},
  { label: 'Marriage Certificate', value: 'MARRIAGE_CERTIFICATE_AUDIT'},
  { label: 'Cedula', value: 'CEDULA_AUDIT'}
]

export const USER_TYPES = [
  { label: 'Administrator', value: 'ADMINISTRATOR'},
  { label: 'Taxpayer', value: 'TAXPAYER'}
]

export const EVENT_TYPES = [
  { label: 'Add', value: 'Add' },
  { label: 'Modify', value: 'Modify' },
  { label: 'Delete', value: 'Delete' },
  { label: 'Log-in', value: 'Log-in' },
  { label: 'Log-out', value: 'Log-out' },
  { label: 'Blocked', value: 'Blocked' },
  { label: 'Reset', value: 'Reset' }
]

export const AUDITABLE_TYPES = [
  { label: 'Administrator', value: 'ADMINISTRATOR' },
  { label: 'Birth Certificate Record', value: 'BIRTH_CERTIFICATE_RECORD' },
  { label: 'Birth Certificate Record Image', value: 'BIRTH_CERTIFICATE_RECORD_IMAGE' },
  { label: 'Birth Certificate Setting', value: 'BIRTH_CERTIFICATE_SETTING' },
  { label: 'BPLS', value: 'BPLS' },
  { label: 'BPLS Basic Calculation', value: 'BPLS_BASIC_CALCULATION' },
  { label: 'BPLS Calculation', value: 'BPLS_CALCULATION' },
  { label: 'BPLS Excess Calculation', value: 'BPLS_EXCESS_CALCULATION' },
  { label: 'BPLS Fixed Amount Calculation', value: 'BPLS_FIXED_AMOUNT_CALCULATION' },
  { label: 'BPLS Fixed Fee', value: 'BPLS_FIXED_FEE' },
  { label: 'BPLS Other Fee', value: 'BPLS_OTHER_FEE' },
  { label: 'BPLS Quantity Calculation', value: 'BPLS_QUANTITY_CALCULATION' },
  { label: 'Business', value: 'BUSINESS' },
  { label: 'Business Activity', value: 'BUSINESS_ACTIVITY' },
  { label: 'Business Line', value: 'BUSINESS_LINE' },
  { label: 'Business Line Requirement', value: 'BUSINESS_LINE_REQUIREMENT' },
  { label: 'Business Nature', value: 'BUSINESS_NATURE' },
  { label: 'Business Permit Application Transmittal', value: 'BUSINESS_PERMIT_APPLICATION_TRANSMITTAL' },
  { label: 'Business Permit Billing', value: 'BUSINESS_PERMIT_BILLING' },
  { label: 'Business Permit Requirement', value: 'BUSINESS_PERMIT_REQUIREMENT' },
  { label: 'Calculation Fire Safety', value: 'CALCULATION_FIRE_SAFETY' },
  { label: 'Cedula', value: 'CDL' },
  { label: 'CMS', value: 'CMS' },
  { label: 'Death Certificate', value: 'DC' },
  { label: 'Death Certificate Record', value: 'DEATH_CERTIFICATE_RECORD' },
  { label: 'Death Certificate Setting', value: 'DEATH_CERTIFICATE_SETTING' },
  { label: 'Endorsing Office', value: 'ENDORSING_OFFICE' },
  { label: 'Endorsing Office Approval', value: 'ENDORSING_OFFICE_APPROVAL' },
  { label: 'Fee Setting', value: 'FEE_SETTING' },
  { label: 'Marriage Certificate', value: 'MC' },
  { label: 'Marriage Certificate Record', value: 'MARRIAGE_CERTIFICATE_RECORD' },
  { label: 'Marriage Certificate Setting', value: 'MARRIAGE_CERTIFICATE_SETTING' },
  { label: 'Option Calculation', value: 'OPTION_CALCULATION' },
  { label: 'Birth Certificate', value: 'PSA' },
  { label: 'Roles', value: 'ROLE' },
  { label: 'Permissions', value: 'PERMISSION' },
  { label: 'Range Calculation', value: 'RANGE_CALCULATION' },
  { label: 'Setting', value: 'SETTING' },
  { label: 'Tax Revenue', value: 'TAX_REVENUE' },
  { label: 'Taxpayer One Time Pin', value: 'TAXPAYER_ONE_TIME_PIN' },
  { label: 'Temporary Registration', value: 'TEMPORARY_REGISTRATION' },
  { label: 'Transaction History', value: 'TRANSACTION_HISTORY' }
];


export const KIND_OF_OWNERSHIP = [
  { label: 'ALL', value: '' },
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const REGISTRATION_STATUS = [
  { label: 'ALL', value: '' },
  { label: 'SUCCESSFUL', value: 'SUCCESSFUL' },
  { label: 'PENDING', value: 'PENDING' }
]

export const BPLS_EVENTS = [
  { "label": "Add Tax Credit", "value": "ADD TAX CREDIT" },
  { "label": "Apply Change Request", "value": "APPLY CHANGE REQUEST" },
  { "label": "Apply Retirement", "value": "APPLY RETIREMENT" },
  { "label": "Approve", "value": "APPROVE" },
  { "label": "Assess Business", "value": "ASSESS BUSINESS" },
  { "label": "Assess Change Request", "value": "ASSESS CHANGE REQUEST" },
  { "label": "Assess Renewal Application", "value": "ASSESS RENEWAL APPLICATION" },
  { "label": "Assess Retirement", "value": "ASSESS RETIREMENT" },
  { "label": "Assign Taxpayer", "value": "ASSIGN TAXPAYER" },
  { "label": "Attach Cedula", "value": "ATTACH CEDULA" },
  { "label": "Auto Assess Business", "value": "AUTO ASSESS BUSINESS" },
  { "label": "Cancel Application", "value": "CANCEL APPLICATION" },
  { "label": "Cancel SOA", "value": "CANCEL SOA" },
  { "label": "Change Application", "value": "CHANGE APPLICATION" },
  { "label": "Create", "value": "CREATE" },
  { "label": "Create Activity", "value": "CREATE ACTIVITY" },
  { "label": "Delinquent Application", "value": "DELINQUENT APPLICATION" },
  { "label": "Expire SOA", "value": "EXPIRE SOA" },
  { "label": "Final Calculate", "value": "FINAL CALCULATE" },
  { "label": "Forward To License", "value": "FORWARD TO LICENSE" },
  { "label": "Generate BIN", "value": "GENERATE BIN" },
  { "label": "Generate SOA", "value": "GENERATE SOA" },
  { "label": "Generate Transmittal", "value": "GENERATE TRANSMITTAL" },
  { "label": "Hold", "value": "HOLD" },
  { "label": "Initial Calculate", "value": "INITIAL CALCULATE" },
  { "label": "New Application", "value": "NEW APPLICATION" },
  { "label": "Paid", "value": "PAID" },
  { "label": "Pre-Register", "value": "PRE-REGISTER" },
  { "label": "Quarterly Application", "value": "QUARTERLY APPLICATION" },
  { "label": "Regenerate Billing", "value": "REGENERATE BILLING" },
  { "label": "Regenerate SOA", "value": "REGENERATE SOA" },
  { "label": "Reject", "value": "REJECT" },
  { "label": "Renewal Application", "value": "RENEWAL APPLICATION" },
  { "label": "Resubmit", "value": "RESUBMIT" },
  { "label": "Retire", "value": "RETIRE" },
  { "label": "Retire Activity", "value": "RETIRE ACTIVITY" },
  { "label": "Retirement Application", "value": "RETIREMENT APPLICATION" },
  { "label": "Return To Permit", "value": "RETURN TO PERMIT" },
  { "label": "Revoke", "value": "REVOKE" },
  { "label": "Select Quarter", "value": "SELECT QUARTER" },
  { "label": "Start License Assessment", "value": "START LICENSE ASSESSMENT" },
  { "label": "Start Permit Assessment", "value": "START PERMIT ASSESSMENT" },
  { "label": "Stop License Assessment", "value": "STOP LICENSE ASSESSMENT" },
  { "label": "Stop Permit Assessment", "value": "STOP PERMIT ASSESSMENT" },
  { "label": "Unhold", "value": "UNHOLD" },
  { "label": "Unretire", "value": "UNRETIRE" },
  { "label": "Unretire Activity", "value": "UNRETIRE ACTIVITY" },
  { "label": "Unrevoke", "value": "UNREVOKE" },
  { "label": "Update", "value": "UPDATE" },
  { "label": "Update Activity", "value": "UPDATE ACTIVITY" },
  { "label": "Update Activity Amount", "value": "UPDATE ACTIVITY AMOUNT" },
  { "label": "Update Business State", "value": "UPDATE BUSINESS STATE" },
  { "label": "Update Calculation Details", "value": "UPDATE CALCULATION DETAILS" },
  { "label": "Update Fee Amount", "value": "UPDATE FEE AMOUNT" },
  { "label": "Update Payment Date", "value": "UPDATE PAYMENT DATE" },
  { "label": "Update Remarks", "value": "UPDATE REMARKS" },
  { "label": "Validate Activity", "value": "VALIDATE ACTIVITY" }
]

export const LCR_EVENTS = [
  { "label": "Approved", "value": "APPROVED" },
  { "label": "Paid Transaction", "value": "PAID TRANSACTION" },
  { "label": "Rejected", "value": "REJECTED" },
  { "label": "Resubmitted Transaction", "value": "RESUBMITTED TRANSACTION" },
  { "label": "Submitted Transaction", "value": "SUBMITTED TRANSACTION" },
  { "label": "Start Assessment", "value": "START ASSESSMENT" },
  { "label": "Stop Assessment", "value": "STOP ASSESSMENT" },
  { "label": "Tagged As For Appearance", "value": "TAGGED AS FOR APPEARANCE" },
  { "label": "Tagged As For Pick-Up", "value": "TAGGED AS FOR PICK-UP" },
  { "label": "Tagged As Issued", "value": "TAGGED AS ISSUED" },
  { "label": "Tagged As Printed", "value": "TAGGED AS PRINTED" },
  { "label": "Updated Information", "value": "UPDATED INFORMATION" },
  { "label": "Updated Registry Number", "value": "UPDATED REGISTRY NUMBER" }
]

export const CEDULA_EVENTS = [
  { "label": "Approved", "value": "APPROVED" },
  { "label": "Generated Cedula", "value": "GENERATED CEDULA" },
  { "label": "Paid Transaction", "value": "PAID TRANSACTION" },
  { "label": "Submit Transaction", "value": "SUBMIT TRANSACTION" },
  { "label": "Start Assessment", "value": "START ASSESSMENT" },
  { "label": "Stop Assessment", "value": "STOP ASSESSMENT" },
  { "label": "Tagged As For-Pickup", "value": "TAGGED AS FOR-PICKUP" },
  { "label": "Tagged As Issued", "value": "TAGGED AS ISSUED" }
]
